var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tipoLote)?_c('div',{staticClass:"tipo-lote badge"},[_c('div',{staticClass:"tipo-lote-card"},[_vm._v(_vm._s(_vm.tipoLote.descricao))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }